import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Scene3D } from "@/components/Scene3D";
import { ChevronDown, Skull, Leaf } from "lucide-react";
import { InstallAppButton } from "@/components/InstallAppButton";

export const HeroSection = () => {
    const scrollToPicks = () => {
        const el = document.getElementById("daily-picks");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    return (
        <section className="relative pp-bg-0 overflow-hidden" data-testid="hero-section">
            <Scene3D />
            <div className="pointer-events-none absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(10,10,15,0.55) 0%, rgba(10,10,15,0.85) 60%, #0a0a0f 100%)" }} aria-hidden />

            <div className="relative max-w-6xl mx-auto px-4 sm:px-6 pt-16 pb-24 sm:pt-24 sm:pb-32 z-10">
                <motion.div
                    initial={{ opacity: 0, y: 14 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                    className="max-w-3xl"
                >
                    <div className="inline-flex items-center gap-2 rounded-full bg-[#0c1f12] border border-[#22c55e]/40 text-[#22c55e] px-3 py-1 text-xs font-mono uppercase">
                        <Leaf className="w-3.5 h-3.5" /> ACTION CODE: HOTSLIP — 100x your picks
                    </div>
                    <h1 className="mt-5 font-display text-7xl sm:text-8xl lg:text-9xl tracking-widest text-white neon-text-purple graffiti-glitch">
                        HOT<span className="text-[#22c55e] neon-text-green">SLIP</span>
                    </h1>
                    <p className="mt-2 font-display text-2xl sm:text-3xl tracking-wider text-[#b7b7c6]">
                        DEMONS. <span className="text-[#ef4444]"><Skull className="inline w-5 h-5 mb-1" /></span> GOBLINS. <span className="text-[#22c55e]"><Leaf className="inline w-5 h-5 mb-1" /></span> DAILY DROPS.
                    </p>
                    <p className="mt-4 text-base sm:text-lg text-[#b7b7c6] max-w-xl">
                        Daily PrizePicks slips, dropped fresh. Free goblin pick for everyone—
                        unlock blue &amp; purple Pro plays, then go full <span className="text-[#ef4444]">demon</span> with Sports Premium.
                    </p>
                    <div className="mt-7 flex flex-col sm:flex-row gap-3 flex-wrap">
                        <Button onClick={scrollToPicks} className="bg-[#6f3fec] hover:brightness-110 text-white text-base h-12 px-6" data-testid="hero-view-picks-button">
                            View Today’s Picks
                        </Button>
                        <Button asChild variant="secondary" className="bg-[#14141c] border border-[#242436] hover:bg-[#1b1b26] text-white h-12 px-6" data-testid="hero-pricing-button">
                            <Link to="/pricing">See Pricing</Link>
                        </Button>
                        <InstallAppButton variant="hero" />
                    </div>
                </motion.div>

                <button onClick={scrollToPicks} className="absolute left-1/2 -translate-x-1/2 bottom-6 text-[#8b8ba0] hover:text-white inline-flex flex-col items-center gap-1" aria-label="Scroll to picks">
                    <span className="text-xs font-mono">SCROLL</span>
                    <ChevronDown className="w-5 h-5 animate-bounce" />
                </button>
            </div>
        </section>
    );
};
